import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { UPDropdownItem } from 'components/dropdown';

export const getAllCountriesNamesRequest = async (language: string): Promise<UPDropdownItem[]> => {
  const response: AxiosResponse<UPDropdownItem[]> = await getApi().get(`Employee/Countries/${language}`);
  return response.data;
};
